import Stack, { StackProps } from "@mui/joy/Stack";

interface Props extends StackProps {
  children: React.ReactNode;
}

const PageWrapper = ({ children, className, sx, ...props }: Props) => {
  return (
    <Stack
      className={`page-wrapper ${className}`}
      sx={{
        flex: "1 1 0%",
        width: "100%",
        p: 4,
        mb: 2,
        pt: 2.5,
        pb: 2,
        ...sx,
      }}
      {...props}
    >
      {children}
    </Stack>
  );
};
export default PageWrapper;
